module.exports = __webpack_public_path__ + "static/CareBearStare-6980cac8b408130c9ad95646c28f7919.jpg";